import type { MediaFilterOption } from '../model/types';

export const getMediaFilterOptionValue = (option: unknown) => {
  return (option as MediaFilterOption).value;
};
